import { render, staticRenderFns } from "./ArtistSelector.vue?vue&type=template&id=0f17a0f4&scoped=true"
import script from "./ArtistSelector.vue?vue&type=script&lang=js"
export * from "./ArtistSelector.vue?vue&type=script&lang=js"
import style0 from "./ArtistSelector.vue?vue&type=style&index=0&id=0f17a0f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f17a0f4",
  null
  
)

export default component.exports